import { useDispatch } from 'react-redux'
import type { AppDispatch } from '../providers/AppProviders'

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
